
<div style="display:none" class="addressScreen" *ngIf="executePaymentService.isFirstStep && !executePaymentService.addressFieldsNeedToBeFilled">
  <div class="flat-container">
    <div class="shortcont">
      <div class="basicrow fix-container">
        <div class="row preview-title">Método de Pago</div>
        <div class="line"></div>
        <div class="basicrow">
          <div class="basicrow">
            <div class="row preview-info">
              Por favor, selecione un método de pago para continuar con el proceso
            </div>
            <div class="preview-option-container" (click)="this.executePaymentService.optionSelected(0)">
              <div class="flex-container">
                <div class="radio-container">
                  <input type="radio" id="radio1" name="grupo1">
                </div>
                <div class="label-container">
                  <label for="radio1">
                    <div class="title-label">
                      Tarjeta de Crédito
                    </div>
                    <div class="description-label">
                      Selecciona esta opción si gustas pagar con una tarjeta de débito o tarjeta de crédito VISA,
                      MASTERCARD o AMERICAN EXPRESS.
                    </div>
                  </label>
                </div>
              </div>
              <label for="radio1" class="card-preview-container">
                <img class="card-preview"
                     src="assets/images/cards/master.png" alt="">
                <img class="card-preview"
                     src="assets/images/cards/visa.png" alt="">
                <img class="card-preview"
                     src="assets/images/cards/amex.png" alt="">
              </label>

            </div>

            <div class="preview-option-container" (click)="this.executePaymentService.optionSelected(1)">
              <div class="flex-container">
                <div class="radio-container">
                  <input type="radio" value="" id="radio2" name="grupo1">
                </div>
                <div class="label-container">
                  <label for="radio2">
                    <div class="title-label">
                      ATH
                    </div>
                    <div class="description-label">
                      Selecciona esta opción si prefieres usar como método de pago una tarjeta ATH. Serás redireccionado
                      al portal web del Banco Popular.
                    </div>
                  </label>
                </div>
              </div>
              <label for="radio2" class="card-preview-container">
                <img
                  class="ath-card"
                  src="data:image/png;base64,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"
                  alt="">
              </label>

            </div>

          </div>
        </div>
        <br>
        <div class="basicrow buttons-container">
          <div class="graybtn" (click)="executePaymentService.cancelFirstStep()"><i class="fa fa-angle-left lefticon"
                                                                                    aria-hidden="true"></i> Cancelar
          </div>
          <div class="redbtn" (click)="executePaymentService.doPayment()">Continuar <i
            class="fa fa-angle-right righticon" aria-hidden="true"></i></div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="addressScreen" *ngIf="executePaymentService.addressFieldsNeedToBeFilled">
  <div class="flat-container">
    <div class="shortcont">
      <div class="basicrow fix-container">
        <div class="basicrow f-lbig f-black roboto-m">Actualice Direcci&oacute;n F&iacute;sica</div>
        <div class="basicrow">
          <div class="basicrow">
            <div class="row">
              <div class="col-xs col-sm-6 col-md-6 col-lg-6">
                <div class="basicrow m-top-i">
                  <label class="label-f">&#42; Indique direcci&oacute;n 1</label>
                  <div class="basicrow rel">
                    <input
                      type="text"
                      maxlength="40"
                      placeholder="Linea 1"
                      class="inp-f qt"
                      [(ngModel)]="executePaymentService.address.address1"
                    />
                    <span class="card-error" *ngIf="executePaymentService.address.address1Error">
                       Este campo es obligatorio
                      </span>

                  </div>
                </div>
              </div>
              <div class="col-xs col-sm-6 col-md-6 col-lg-6">
                <div class="basicrow m-top-i">
                  <label class="label-f">&#42; Indique direcci&oacute;n 2</label>
                  <div class="basicrow">
                    <input
                      type="text"
                      maxlength="40"
                      placeholder="Linea 2"
                      class="inp-f"
                      [(ngModel)]="executePaymentService.address.address2"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs col-sm-6 col-md-4 col-lg-4">
                <div class="basicrow m-top-i">
                  <label class="label-f">&#42; &#191;Ciudad</label>
                  <div class="basicrow rel">
                    <input
                      type="text"
                      maxlength="40"
                      placeholder="Ciudad"
                      class="inp-f qt"
                      [(ngModel)]="executePaymentService.address.city"
                    />
                    <span class="card-error" *ngIf="executePaymentService.address.cityError">
                            Este campo es obligatorio
                           </span>
                  </div>
                </div>
              </div>

              <div class="col-xs col-sm-6 col-md-4 col-lg-4">
                <div class="basicrow m-top-i">
                  <div class="basicrow">
                    <label class="label-f">&#42; Estado</label>
                    <select
                      class="sel-f"
                      name="state"
                      [(ngModel)]="executePaymentService.address.state"
                      (change)="onChangeState(executePaymentService.address.state)"
                    >
                      <option value="PR" selected>PR</option>
                      <option [value]="state" *ngFor="let state of executePaymentService.states">{{ state }}</option>

                    </select>
                    <span class="card-error" *ngIf="executePaymentService.address.stateError">
                          Este campo es obligatorio
                        </span>
                  </div>
                </div>
              </div>

              <div class="col-xs col-sm-6 col-md-4 col-lg-4">
                <div class="basicrow m-top-i">
                  <div class="basicrow">
                    <label [appOnlyNumber] type="text" maxlength="5" class="label-f">&#42; C&oacute;digo Postal</label>
                    <input
                      type="text"
                      maxlength="5"
                      class="inp-f"
                      [(ngModel)]="executePaymentService.address.zipCode"
                    />
                    <span class="card-error" *ngIf="executePaymentService.address.zipCodeError">
                          Este campo es obligatorio
                        </span>
                    <span class="card-error" *ngIf="executePaymentService.address.zipCodeErrorFormat">
                         Debe ser de 5 digitos y solo números son permitidos
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br>

        <div class="basicrow buttons-container" id="continue_btn">
          <div class="graybtn" (click)="cancel()"><i class="fa fa-angle-left lefticon" aria-hidden="true"></i> Regresar
          </div>
          <div class="redbtn" (click)="validateAddressForm()">Continuar <i class="fa fa-angle-right righticon"
                                                                           aria-hidden="true"></i></div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="addressScreen" *ngIf="executePaymentService.applyPaymentValidation">
  <div class="flat-container">
    <div class="shortcont">
      <div class="basicrow top-space fix-container">
        <div class="card-content" *ngIf="executePaymentService.applyPaymentResponse">
          <!--
          <div
            class="card-item"
            *ngFor="let item of executePaymentService.applyPaymentResponse.paymentMethod"
            [ngClass]="executePaymentService.cardType === item.methodDescription ? 'cardTrue' : ''"
          >
            <img class="card-img" [src]="item.methodLogoUrl" alt="card-image">
          </div>

          --->

          <div
            class="card-item"
            *ngFor="let item of executePaymentService.applyPaymentResponse.paymentMethod"
            [ngClass]="executePaymentService.cardType === item.methodDescription ? 'cardTrue' : ''"
          >


            <img class="card-img"
                 *ngIf="item.methodCode.toString().toLocaleLowerCase().includes('m')"
                 src="assets/images/cards/master.png" alt="">
            <img class="card-img"
                 *ngIf="item.methodCode.toString().toLocaleLowerCase().includes('v')"
                 src="assets/images/cards/visa.png" alt="">
            <img class="card-img"
                 *ngIf="item.methodCode.toString().toLocaleLowerCase().includes('x')"
                 src="assets/images/cards/amex.png" alt="">

          </div>


        </div>
        <div class="basicrow">
          <div class="basicrow">
            <div>
              <div>
                <div class="bottom-space">
                  <p> &#42; Titular</p>
                  <input
                    class="padding-input large-input"
                    name="cardName"
                    [(ngModel)]="executePaymentService.cardName"
                    type="text"
                  >
                </div>

                <div class="payment-form bottom-space">
                  <div class="input-content fix-bottom">
                    <p class=""> &#42; Numero de Tarjeta</p>
                    <input
                      class="padding-input large-input"
                      name="cardNumber"
                      [(ngModel)]="executePaymentService.cardNumberString"
                      type="text"
                      maxlength="16"
                      (change)="executePaymentService.isValidCreditCardNumber(executePaymentService.cardNumberString)"
                      autocomplete="off"
                    >
                    <span class="card-error" *ngIf="!executePaymentService.isValidCard">
                        Tarjeta Inválida
                    </span>
                    <span class="card-error" *ngIf="executePaymentService.isTheCardNumberEmpty">
                        Este campo es obligatorio
                    </span>
                  </div>
                  <div class="input-content fix-bottom">
                    <p> &#42; CCV</p>
                    <input
                      class="payment-input padding-input"
                      type="password"
                      [(ngModel)]="executePaymentService.ccv"
                      name="ccv"
                      maxlength="4"
                      (change)="executePaymentService.ccvChanged()"
                      autocomplete="off"
                    >
                    <span class="card-error" *ngIf="executePaymentService.isTheCcvEmpty">
                          Este campo es obligatorio
                      </span>
                    <span class="card-error" *ngIf="executePaymentService.isTheCcvError">
                          Intente nuevamente
                      </span>
                  </div>
                </div>
              </div>

              <div class="payment-form bottom-space">
                <div class="input-content">
                  <p class=""> &#42; Fecha de Expiración</p>
                  <div class="select-content bottom-space">
                    <select
                      [(ngModel)]="executePaymentService.expirationYear"
                      name="expirationYear"
                      (change)="executePaymentService.changeExpirationMonth()"
                    >
                      <option [value]="''" disabled selected>Año</option>
                      <option
                        [value]="item"
                        *ngFor="let item of executePaymentService.years">{{ item }}</option>
                    </select>

                    <div class="date-slash">/</div>
                    <select
                      [(ngModel)]="executePaymentService.expirationMonth"
                      name="expirationMonth"
                      (change)="executePaymentService.changeExpirationMonth()"
                    >
                      <option [value]="''" disabled selected>mes</option>
                      <option
                        [value]="item"
                        *ngFor="let item of executePaymentService.months">{{ item }}</option>
                    </select>
                    <span class="card-error" *ngIf="executePaymentService.cardIsExpired">
                            Tarjeta vencida, verifique información
                          </span>
                  </div>
                </div>
                <div class="input-content">
                  <p class=""> &#42; Zip Code</p>
                  <input
                    class="padding-input large-input"
                    name="zipCode"
                    [(ngModel)]="executePaymentService.address.zipCode"
                    type="text"
                    maxlength="5"
                    (change)="executePaymentService.zipCodeChanged()"
                    autocomplete="off"
                  >
                  <span class="card-error" *ngIf="!executePaymentService.isValidZip">
                       Zip code invalido
                    </span>
                  <span class="card-error" *ngIf="executePaymentService.isEmptyZipCode">
                        Este campo es obligatorio
                    </span>
                </div>
              </div>

            </div>
          </div>
        </div>
        <br>
        <div class="basicrow buttons-container2">
          <div class="graybtn" (click)="executePaymentService.applyPaymentValidationOff()"><i
            class="fa fa-angle-left lefticon" aria-hidden="true"></i> Cancelar
          </div>
          <div class="redbtn" (click)="executAuthorizePayment()">Continuar <i class="fa fa-angle-right righticon"
                                                                              aria-hidden="true"></i></div>
        </div>
      </div>
    </div>
  </div>
</div>



